import { useState } from 'react';
import { Button } from '@blueprintjs/core';
import Modal from '../../templates/popups/Modal';
import { FaTrash } from 'react-icons/fa'; 
import EditableRow from './EditableRow';
import chevron from '../../img/icons/chevron.png';
import doubleChevron from '../../img/icons/double-chevron.png';
import { RefAlertsHook, useAddAlert, useAlertsPagination, useDeleteAlert } from '../hooks/TransactionsHooks';

const Loader = () => (
    <div className="spinner" style={{
        display: 'inline-block',
        width: '40px',
        height: '40px',
        border: '4px solid rgba(255, 255, 255, 0.3)',
        borderRadius: '50%',
        borderTop: '4px solid white',
        animation: 'spin 1s linear infinite'
    }}></div>
);

function AlertasModal({ isOpen, handleClose, isMobile = false }) {

  const alerts = RefAlertsHook();

  const addAlert = useAddAlert();
  const deleteAlert = useDeleteAlert();

  const {
    currentPage,
    totalPages,
    currentAlerts,
    nextPage,
    prevPage,
    firstPage,
    lastPage
  } = useAlertsPagination(alerts);

  const [addingNewAlert, setAddingNewAlert] = useState(false);
  const [newAlert, setNewAlert] = useState({
    alert_type: "above",
    level: ""
  });

  const [errorMessage, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const alertTypeLabels = {
    above: "Alza",
    below: "Baja"
  };

  const handleAddAlert = async () => {

    setLoading(true);

    try {

      await addAlert(newAlert);

      setAddingNewAlert(false);

      setNewAlert({
        alert_type: "above",
        level: ""
      });

      setErrorMessage("");

    } catch (error) {

      setErrorMessage(error.message);

    } finally {

      setLoading(false);

    }
  };

  const handleDeleteAlert = async (alertId) => {

    setLoading(true);

    try {

      await deleteAlert(alertId);

    } catch (error) {

      setErrorMessage("Error al eliminar alerta");

    } finally {

      setLoading(false);

    }
  };

  const handleCancelAdd = () => {

    setAddingNewAlert(false);

    setNewAlert({
      alert_type: "above",
      level: ""
    });

    setErrorMessage("");
  };

  const modalWidth = isMobile ? 90 : 50;
  const tableFontSize = isMobile ? '12px' : '18px';

  return (
    <Modal
      show={isOpen}
      doAccept={null}
      showCancel={false}
      doCancel={handleClose}
      widthPercentage={modalWidth}
      style={{ padding: "20px" }}
    >
      <div
        style={{
          position: "relative",
          textAlign: "center",
          paddingBottom: "10px"
        }}
      >
        <h2 style={{ margin: 0 }}>ALERTAS</h2>

        <Button
          icon="plus"
          text="Agregar alerta"
          style={{
            position: "absolute",
            top: "0",
            right: "0"
          }}
          onClick={() => setAddingNewAlert(true)}
        />
      </div>

      {alerts.length === 0 && !addingNewAlert ? (
        <div
          style={{
            textAlign: "center",
            color: "white",
            marginTop: "20px"
          }}
        >
          ¡No tienes alertas creadas!
        </div>
      ) : (
        <>
          {/* PAGINATION */}
          <div
            className="pagination"
            style={{
              textAlign: "center",
              marginTop: "20px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center"
            }}
          >
            <button onClick={firstPage} disabled={currentPage === 1}>
              <img
                src={doubleChevron} alt=""
                style={{
                  width: "16px",
                  transform: "scaleX(-1)",
                  filter: "invert(100%)"
                }}
              />
            </button>

            <button onClick={prevPage} disabled={currentPage === 1}>
              <img
                src={chevron} alt=""
                style={{
                  width: "16px",
                  transform: "scaleX(-1)",
                  filter: "invert(100%)"
                }}
              />
            </button>

            <span style={{ margin: "0 10px", color: "white" }}>
              Página {currentPage} de {totalPages}
            </span>

            <button onClick={nextPage} disabled={currentPage === totalPages}>
              <img
                src={chevron} alt=""
                style={{ width: "16px", filter: "invert(100%)" }}
              />
            </button>

            <button onClick={lastPage} disabled={currentPage === totalPages}>
              <img
                src={doubleChevron} alt=""
                style={{ width: "16px", filter: "invert(100%)" }}
              />
            </button>
          </div>

          {/* TABLE */}
          <div
            className="contenedor-tabla"
            style={{ fontSize: tableFontSize, marginTop: "5px" }}
          >
            <div className="flex-tabla">

              <div className="flex-fila header-row">
                <div className="flex-celda" style={{ width: "40%", textAlign: "center" }}>
                  Nivel
                </div>

                <div className="flex-celda" style={{ width: "40%", textAlign: "center" }}>
                  Supera
                </div>

                <div className="flex-celda" style={{ width: "5%" }} />
              </div>

              {currentAlerts.map((alert, index) => (
                <div
                  key={alert.id}
                  className={`flex-fila ${
                    index % 2 === 0 ? "even-row" : "uneven-row"
                  }`}
                >
                  <div className="flex-celda" style={{ width: "40%", textAlign: "center" }}>
                    {alert.level}
                  </div>

                  <div className="flex-celda" style={{ width: "40%", textAlign: "center" }}>
                    {alertTypeLabels[alert.alert_type] || alert.alert_type}
                  </div>

                  <div className="flex-celda" style={{ width: "5%", textAlign: "center" }}>
                    <FaTrash
                      style={{ cursor: "pointer", height: "16px" }}
                      onClick={() => handleDeleteAlert(alert.id)}
                    />
                  </div>
                </div>
              ))}

              {addingNewAlert && (
                <EditableRow
                  newAlert={newAlert}
                  setNewAlert={setNewAlert}
                  handleAddAlert={handleAddAlert}
                  handleCancelAdd={handleCancelAdd}
                />
              )}

            </div>
          </div>
        </>
      )}

      {loading && (
        <div style={{ textAlign: "center", marginTop: "10px" }}>
          <Loader />
        </div>
      )}

      {errorMessage && (
        <div style={{ color: "red", marginTop: "10px", textAlign: "center" }}>
          {errorMessage}
        </div>
      )}
    </Modal>
  );
}

export default AlertasModal;
